import { GridSortModel } from '@mui/x-data-grid';

export const getTableSorting = (sortModal: GridSortModel) => {
  return sortModal.map((item) => ({ [item.field]: item.sort === 'asc' ? 1 : -1 }));
};
